import { CheckoutDeliveryAddressClearedEvent } from "@spartacus/checkout/base/root";

export class SsabCheckoutDeliveryAddressClearedEvent extends CheckoutDeliveryAddressClearedEvent {
}